import ArrowDown from '@mui/icons-material/KeyboardArrowDownRounded';
import { FormHelperText, InputAdornment, SxProps } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import React from 'react';

import { Form } from './styles';

export type Option = {
  label: string;
  value: string | number;
};

interface SelectProps {
  label?: string;
  options?: Option[];
  id?: string;
  onChange?: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value?: string | undefined;
  name?: string;
  error?: boolean | undefined;
  helperText?: string | false | undefined;
  endAdornment?: React.ReactNode;
  sx?: SxProps;
  disabled?: boolean;
}

export const CustomSelect: React.FC<SelectProps> = ({
  label,
  options = undefined,
  id,
  onChange,
  onBlur,
  value,
  name,
  error,
  helperText,
  endAdornment,
  sx,
  disabled = false,
}) => {
  return (
    <Form variant="standard" sx={sx}>
      <InputLabel id={id} error={error}>
        {label}
      </InputLabel>
      <Select
        labelId={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        IconComponent={() => (
          <InputAdornment position="end">
            <ArrowDown />
          </InputAdornment>
        )}
        endAdornment={endAdornment}
        error={error}
        defaultValue=""
      >
        {options?.map((option, index) => (
          <MenuItem key={index} value={option?.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </Form>
  );
};

export default CustomSelect;
